import type { Handler } from 'mitt'
import mitt from 'mitt'

type Events = Record<string, any> & {
  // 'show-message': string
}

const emitter = mitt<Events>()

const onceMap = new Map<string, Handler<Events[string]>[]>()

function once(event: string, handler: Handler<Events[string]>) {
  if (!onceMap.has(event)) {
    onceMap.set(event, [])
  }

  const wrappedHandler = (payload: Events[string]) => {
    handler(payload)
    emitter.off(event, wrappedHandler)
  }

  onceMap.get(event)?.push(wrappedHandler)
  emitter.on(event, wrappedHandler)
}

const mitter = {
  ...emitter,
  once,
}

export default mitter
